/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import Cookies from 'js-cookie';
import './style.sass';
import httpService from '../../../api/httpLocationService';
import { validationPatterns } from '../../../utils/validationPatterns';
import { withFormik } from 'formik';
import classNames from "classnames";


const generateDataForSubmit =(selectedLocations, link) => {
  const selectedLocationSubmit = [];

  selectedLocations.forEach((location) => {
    const gtagData = {
      id: location.loc_id,
      name: location.name,
      list_name: 'List-view',
      category: location.category_for_ga,
      list_position: location.position_index ? location.position_index.toString() : '1',
      price: '1.0',
    };

    selectedLocationSubmit.push(gtagData);
  });

  return selectedLocationSubmit;
};

class OrderForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      emailIsValid: false,
      showPolicyModal: false,
      showGuideModal: false,
      sendEvent: false,
      name: '',
      firm: '',
      email: '',
      phone: '',
      comments: '',
      formValuesUpd: false
    };

    this.handleGuideModalShow = this.handleGuideModalShow.bind(this);
    this.handleGuideModalClose = this.handleGuideModalClose.bind(this);
    this.handlePolicyModalShow = this.handlePolicyModalShow.bind(this);
    this.handlePolicyModalClose = this.handlePolicyModalClose.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleInputEmailChange = this.handleInputEmailChange.bind(this);
    this.handleGoogleEventFieldsBlur = this.handleGoogleEventFieldsBlur.bind(this);
    this.onMouseLeaveHandler = this.onMouseLeaveHandler.bind(this)
    this.noLocation = this.noLocation.bind(this)
  }

  componentDidMount() {
    const userAutofillData = JSON.parse(localStorage.getItem('userAutofillData'));

    if (userAutofillData) {
      this.setState({
        name: userAutofillData.name,
        firm: userAutofillData.firm,
        email: userAutofillData.email,
        phone: userAutofillData.phone,
      });
    } else {
      this.setState({
        phone: this.props.countryCode,
      });
    }
  };

  componentDidUpdate(prevProps) {
    if (prevProps.droppingAnimation && !this.props.droppingAnimation){
      this.processingUncompletedOrder();
    }
  };

  processingUncompletedOrder = () => {
    const {selectedLocations} = this.props
      const { name, email, firm, phone, comments } = this.props.values;

      if (name && this.validateEmail(email)){
        if (this.noLocation()){
          const data = {
            email,
            authenticity_token: this.props.formAuthToken
          };

          httpService.deleteUncompletedOrder(data);
        } else {

          const location_ids = selectedLocations.length === 0 ? [this.props.location.loc_id] : selectedLocations.map(location => location.loc_id)

          const data = {
              name,
              firm,
              email,
              phone,
              authenticity_token: this.props.formAuthToken,
              location_ids: location_ids,
              comments: comments || '',
          };

          httpService.postFormUncompletedOrder(data);
        }
      }
  }

  generateGoogleData = location => ({
    items: [
      {
        id: location.loc_id.toString(),
        name: location.name,
        list_name: 'List-view',
        category: location.gategory_for_ga,
        list_position: location.position_index.toString(),
        price: '1.0',
      },
    ],
  });

  validateEmail = (email) => {
    /* eslint-disable max-len, no-useless-escape */
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    /* eslint-disable max-len, no-useless-escape */

    return re.test(String(email).toLowerCase());
  };

  removeFromCard(location) {
    if (typeof gtag === 'function') {
      gtag('event', 'remove_from_cart', this.generateGoogleData(location));
    }
    this.props.removeLocationFromOrder(location.loc_id);
    this.setState({ formValuesUpd: true });
  }

  handleInputChange(event) {
    this.setState({ [event.target.name]: event.target.value });
    this.setState({ formValuesUpd: true });
  }

  handleInputEmailChange(event) {
    const { value } = event.target;
    const isValid = this.validateEmail(value);

    this.setState({
      emailIsValid: isValid,
      email: value,
    });
  }

  handlePolicyModalShow() {
    this.setState({ showPolicyModal: true });
  }

  handlePolicyModalClose() {
    this.setState({ showPolicyModal: false });
  }

  handleGuideModalShow() {
    this.setState({ showGuideModal: true });
  }

  handleGuideModalClose() {
    this.setState({ showGuideModal: false });
  }

  handleGoogleEventFieldsBlur() {
    if (typeof gtag === 'function') {
      const {
        name, firm, emailIsValid, sendEvent,
      } = this.state;

      if (!sendEvent) {
        if (name && firm && emailIsValid) {
          gtag('event', 'begin_checkout', { items: generateDataForSubmit(this.props.selectedLocations) });
          this.setState({ sendEvent: true });
        }
      }
    }
  }

  noLocation() {
    const {detailsPageCheck, disableSubmit, location} = this.props;

    if(detailsPageCheck)
      return (location.state === "closed")
    else
      return (disableSubmit.length === 0)
  }

  onMouseLeaveHandler() {
    if (this.state.formValuesUpd) {
      this.setState({ formValuesUpd: false });
      this.processingUncompletedOrder();
    }
  }

  render() {
    const {
      values,
      animatedLocation,
      selectedLocations,
      guide,
      policy,
      formAuthToken,
      touched,
      errors,
      handleChange,
      handleBlur,
      handleSubmit,
      isMobile,
    } = this.props;

    const selectedBlock = classNames('selected-locations', {
      'more-three-location': selectedLocations.length > 3,
    });

    return (
      <div
        className="box-shadow js-order-form order-form__container"
        id="main-order-form"
        onMouseLeave={this.onMouseLeaveHandler}
        style={isMobile ? { marginTop: '15px' } : null}
      >

        <div className="sidebar">
          <h3 className="sidebar-header arrowed arrowed--g colored--o" style={isMobile ? { marginRight: '30px' } : null}>
            {I18n.t('sidebar.order.title')}
          </h3>
          <p>
            <strong>
              {selectedLocations.length > 0
                ? I18n.t('sidebar.order.you_selected_locations')
                : I18n.t('sidebar.order.errors.no_location_selected')}
            </strong>
            {(selectedLocations.length === 0 && guide) && (
            <span
              className="button--link"
              role="button"
              tabIndex={0}
              onKeyPress={() => {}}
              onClick={this.handleGuideModalShow}
            >
              (?)
            </span>
            )}
          </p>
          <div className={selectedBlock} id="flying-destination">
            {selectedLocations.map(location => (
              <div key={location.loc_id}>
                {(animatedLocation.loc_id !== location.loc_id) && (
                  <div className="selected-location">
                    <a href={location.link}>{location.name}</a>
                    <i
                      className="selected-location__delete"
                      role="button"
                      tabIndex="0"
                      onClick={() => this.removeFromCard(location)}
                      onKeyPress={() => {
                      }}
                    />
                  </div>
                )}
              </div>
            ))}
          </div>

          <form
            name="orderForm"
            className="order-form"
            onSubmit={handleSubmit}
          >
            <input
              name="authenticity_token"
              value={formAuthToken}
              type="hidden"
            />
            {selectedLocations.map(location => (
              <input
                key={location.loc_id}
                name={`centers[${location.loc_id}]`}
                defaultValue={location.loc_id}
                type="text"
                hidden
              />
            ))}
            <div className="form-group">
              <label htmlFor="name">{I18n.t('sidebar.order.form.name')}</label>
              <input
                name="name"
                type="text"
                value={values.name}
                id="name"
                onChange={e => {
                  handleChange(e);
                  this.handleInputChange(e)
                }}
                onBlur={e => {
                  handleBlur(e);
                  this.handleGoogleEventFieldsBlur()
                }}
                className={
                  touched.name ? (errors.name ? 'error' : 'is-valid') : null
                }
              />

              <div className="validation-message">
                {touched.name && errors.name ? errors.name : null}
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="firm">{I18n.t('sidebar.order.form.company')}</label>
              <input
                name="firm"
                id="firm"
                type="text"
                value={values.firm}
                onChange={e => {
                  handleChange(e);
                  this.handleInputChange(e)
                }}
                onBlur={e => {
                  handleBlur(e);
                  this.handleGoogleEventFieldsBlur()
                }}
                className={
                  touched.firm ? (errors.firm ? 'error' : 'is-valid') : null
                }
              />

              <div className="validation-message">
                {touched.firm && errors.firm ? errors.firm : null}
              </div>
            </div>


            <div className="form-group">
              <label htmlFor="email">{I18n.t('sidebar.order.form.email')}</label>
              <input
                name="email"
                value={values.email}
                id="email"
                type="text"

                onChange={e => {
                  handleChange(e);
                  this.handleInputEmailChange(e)
                }}
                onBlur={e => {
                  handleBlur(e);
                  this.handleGoogleEventFieldsBlur()
                }}
                className={
                  touched.email ? (errors.email ? 'error' : 'is-valid') : null
                }
              />

              <div className="validation-message">
                {touched.email && errors.email ? errors.email : null}
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="phone">
              {I18n.t('sidebar.order.form.phone')}
              &nbsp;
              {I18n.t('sidebar.order.form.phone_country_code')}
            </label>
              <input
                name="phone"
                value={values.phone}
                id="phone"
                onChange={e => {
                  handleChange(e);
                  this.handleInputChange(e)
                }}
                onBlur={e => {
                  handleBlur(e);
                  this.handleGoogleEventFieldsBlur()
                }}
                className={
                  touched.phone ? (errors.phone ? 'error' : 'is-valid') : null
                }
              />

              <div className="validation-message">
                {touched.phone && errors.phone ? errors.phone : null}
              </div>
            </div>


            <label htmlFor="comments">{I18n.t('sidebar.order.form.comments')}</label>
            <textarea
              name="comments"
              value={values.comments}
              onChange={e => {
                handleChange(e);
                this.handleInputChange(e)
              }}
            />

            <button className="form-submit" type="submit" disabled={this.noLocation()}>
              {I18n.t('sidebar.order.errors.request_information')}
            </button>
          </form>


          {policy && (
            <div className="privacy-url">
              <button type="button" className="button--link" onClick={this.handlePolicyModalShow}>
                {I18n.t('sidebar.order.privacy_link')}
              </button>
            </div>
          )}

          {guide && (
            <Modal
              className="header-modals"
              show={this.state.showGuideModal}
              onHide={this.handleGuideModalClose}
            >
              <Modal.Header closeButton />
              <Modal.Body>
                <div dangerouslySetInnerHTML={{ __html: guide }} />
              </Modal.Body>
            </Modal>
          )}

          {policy && (
            <Modal
              className="header-modals"
              show={this.state.showPolicyModal}
              onHide={this.handlePolicyModalClose}
            >
              <Modal.Header closeButton />
              <Modal.Body>
                <div dangerouslySetInnerHTML={{ __html: policy }} />
              </Modal.Body>
            </Modal>
          )}
        </div>
      </div>
    );
  }
}

OrderForm.propTypes = {
  removeLocationFromOrder: PropTypes.func,
  countryCode: PropTypes.string,
  policy: PropTypes.string,
  guide: PropTypes.string,
  formAuthToken: PropTypes.string,
  selectedLocations: PropTypes.arrayOf(PropTypes.object),
  animatedLocation: PropTypes.oneOfType([PropTypes.object]),
  disableOrderButton: PropTypes.func,
  disableSubmit: PropTypes.arrayOf(PropTypes.object),
  locationList: PropTypes.arrayOf(PropTypes.object),
};

OrderForm.defaultProps = {
  removeLocationFromOrder: () => true,
  countryCode: '',
  selectedLocations: [],
  animatedLocation: {},
  policy: '',
  guide: '',
  disableOrderButton: () => true,
  disableSubmit: [],
  formAuthToken: '',
  locationList: [],
};

// export default OrderForm;

const getUserInfo = () => {
  let clientInfo = {
    name: '',
    firm: '',
    email: '',
    phone: '',
    comments: '',
  };

  const userAutofillData = JSON.parse(localStorage.getItem('userAutofillData'));
  if (userAutofillData) {
    clientInfo = {...clientInfo, ...userAutofillData,}
  }

  return clientInfo
};

const { name, email, firm, phone, comments } = getUserInfo();

const ValidatedOrderForm = withFormik({
  mapPropsToValues: (bag) => ({name, email, firm, phone: phone ? phone : bag.countryCode, comments}),

  validate: values => {
    let errors = {};
    if (!values.name) {
      errors.name = I18n.t('sidebar.order.form.required-field');
    } else if (!validationPatterns.name.test(values.name)) {
      errors.name = I18n.t('sidebar.order.form.invalid-name');
    }
    if (!values.firm) {
      errors.firm = I18n.t('sidebar.order.form.required-field');
    } else if (!validationPatterns.firm.test(values.firm)) {
      errors.firm = I18n.t('sidebar.order.form.invalid-firm');
    }

    if (!values.email) {
      errors.email = I18n.t('sidebar.order.form.required-field');
    } else if (!validationPatterns.email.test(values.email)) {
      errors.email = I18n.t('sidebar.order.form.invalid-email');
    }

    if (!values.phone) {
      errors.phone = I18n.t('sidebar.order.form.required-field');
    } else if (!validationPatterns.phone.test(values.phone.replace(/[-\s()]/g, ''))) {
      errors.phone = I18n.t('sidebar.order.form.invalid-phone');
    }

    return errors;
  },

  handleSubmit: (values, bag) => {
    bag.props.disableOrderButton();
    const { name, email, firm, phone, comments } = values;
    const locId = bag.props.location ? bag.props.location.loc_id : null


    localStorage.setItem('userAutofillData', JSON.stringify({
      name: name,
      firm: firm,
      email: email,
      phone: phone,
    }));

    const data = {
      name,
      firm,
      email,
      phone,
      authenticity_token: bag.props.formAuthToken,
      location_ids: [],
      comments: comments || '',
    };

    if (bag.props.selectedLocations.length === 0 && locId) {
      const lastLocationLink = window.location.pathname;


      if (typeof gtag === 'function') {
        gtag(
          'event',
          'purchase',
          { transaction_id: '24.031608523954162', items: generateDataForSubmit(new Array(bag.props.location)) },
        );
      }


      Cookies.set(`order${locId}`, locId, { expires: 14 });
      localStorage.setItem('lastLink', JSON.stringify(lastLocationLink));
      data.location_ids.push(locId);

    } else {
      if (typeof gtag === 'function') {
        gtag(
          'event',
          'purchase',
          { transaction_id: '24.031608523954162', items: generateDataForSubmit(bag.props.selectedLocations) },
        );
      }

      const lastLocationLink = bag.props.selectedLocations[bag.props.selectedLocations.length - 1].link;
      const locationIds = bag.props.selectedLocations.map(elem => elem.loc_id);

      locationIds.map(elem => Cookies.set(`order${elem}`, elem, { expires: 14 }));
      localStorage.setItem('lastLink', JSON.stringify(lastLocationLink));

      bag.props.selectedLocations.map((elem) => {
        data.location_ids.push(elem.loc_id);
      });
    }

    httpService.postFormOrder(data)
      .then((response) => {
        window.location.replace(response.redirect);
      });
  },

  displayName: 'OrderForm', // helps with React DevTools
})(OrderForm);

export default ValidatedOrderForm;
